import { z } from 'zod'

export const ContactSchemaZ = z.object({
  fullName: z.string().trim().min(1, {
    message: 'Pole jest wymagane'
  }),
  email: z
    .string()
    .trim()
    .min(1, {
      message: 'Pole jest wymagane'
    })
    .email({
      message: 'Podaj poprawny adres e-mail'
    }),
  topic: z.string().trim().min(1, { message: 'Pole jest wymagane' }),
  content: z.string().trim().min(1, {
    message: 'Pole jest wymagane'
  })
})

export type ContactSchema = z.infer<typeof ContactSchemaZ>
